export enum GameHint {
  revealFirstLetter = 'revealFirstLetter'
}

export const allGameHints: GameHint[] = Object.values(GameHint);
